import reportWebVitals from "@/reportWebVitals";
import { StrictMode, Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "app/store";
import { getEnv } from "app/utils";

const App = lazy(() => import("@/App"));
const LhsApp = lazy(() => import("@lhs/LhsApp"));
const OssApp = lazy(() => import("@oss/OssApp"));
const EwgApp = lazy(() => import("@ewg/EwgApp"));
const SnsApp = lazy(() => import("@sns/SnsApp"));
const AldApp = lazy(() => import("@ald/AldApp"));
const LxsApp = lazy(() => import("@lxs/LxsApp"));

const getApp = () => {
  switch (getEnv("CUSTOMER_SOLUTION")) {
    case "LHS":
      return <LhsApp />;
    case "OSS":
      return <OssApp />;
    case "EWG":
      return <EwgApp />;
    case "SNS":
      return <SnsApp />;
    case "ALD":
      return <AldApp />;
    case "LXS":
      return <LxsApp />;
    default:
      // Demo
      return <App />;
  }
};

// used to mitigate the problem with vite trying to load old chunks that no longer exist
// fallback in case that the RouterErrorHandler doesn't work, set in a timeout to give
// route error handler time to handle it gracefully
window.addEventListener("vite:preloadError", () =>
  setTimeout(() => {
    window.location.reload();
  }, 3000),
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const disableStrictMode = getEnv("DISABLE_STRICT_MODE", false);

let reactApp = (
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <Suspense>{getApp()}</Suspense>
    </PersistGate>
  </Provider>
);

if (!disableStrictMode) {
  reactApp = <StrictMode>{reactApp}</StrictMode>;
}

root.render(reactApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
